import { useEffect, useState } from 'react';
import { Heading } from 'react-aria-components';

import { useI18n } from 'context/i18n';
import { hasToRenderGiftHat } from 'utils/nnormal';
import { GIFT_BAG_BASE } from 'utils/constants/products';
import { useLocale } from 'hooks';
import { getDomainValue } from 'utils/domain';

import { Dialog, DialogRoot, DialogX } from 'components/ui/dialog';

const imgCustom = {
  JP: {
    className: 'max-sm:max-h-[300px] sm:max-w-[420px] flex items-center',
    src: '/assets-new/xmas22-jp.png',
  },
  KR: {
    className: 'max-sm:max-h-[300px] sm:max-w-[280px]',
    src: '/assets-new/BAG_MAIN_LF.jpg',
  },
  TH: {
    className: 'max-sm:max-h-[300px] sm:max-w-[280px]',
    src: '/assets-new/gwp_th.png',
  },
};

const customGiftBagImages = ['TH']; // hasta que no llegue de api o algo cambiemos esta array y au

export function GiftBagModal() {
  const {
    t,
    profileData: { config },
  } = useI18n();
  const { country } = useLocale();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.showGiftBagPopUp = () => {
      setIsOpen(true);
    };
    return () => {
      window.showGiftBagPopUp = undefined;
    };
  }, []);

  const renderGifHat = hasToRenderGiftHat(t, country);
  return (
    <DialogRoot
      isOpen={isOpen}
      onOpenChange={(isOpen) => {
        setIsOpen(isOpen);
      }}
      showOverlay
      position="bottom-right"
    >
      <Dialog className="p-0">
        <Heading level={2} className="sr-only">
          gift-bag-modal
        </Heading>
        <DialogX absolute />
        <div>
          <div
            id="modal-gift-content"
            className="flex flex-col sm:flex-row [&>div]:flex-1"
            // className={`${styles.modalContent} ${visible ? styles.modalContentVisible : ''} `}
          >
            {getDomainValue({
              camper:
                customGiftBagImages.includes(country) && imgCustom[country] !== null ?
                  <div className={imgCustom[country].className}>
                    <picture>
                      <img src={imgCustom[country].src} alt={'Image of gift Bag photo'} width={'100%'} height={'100%'} className="object-cover" />
                    </picture>
                  </div>
                : config?.sku_gift_purchase ?
                  <div className="max-sm:max-h-[300px] sm:max-w-[280px]">
                    <picture>
                      <img
                        src={`${GIFT_BAG_BASE}/${config.sku_gift_purchase}.jpg`}
                        alt={'Image of gift Bag photo'}
                        width={'100%'}
                        height={'100%'}
                        className="object-cover"
                      />
                    </picture>
                  </div>
                : null,
              camperlab: 'camper',
              nnormal:
                renderGifHat ?
                  <div className="max-sm:max-h-[300px] sm:max-w-[280px]">
                    <picture>
                      <img
                        src="https://cloud.nnormal.com/is/image/JGVzaG9wMDNtYmlnZ3JleSQ=/NA6HB1U-001_L.jpg"
                        alt={'Image of gift Bag photo'}
                        width={'100%'}
                        height={'100%'}
                        className="object-cover"
                      />
                    </picture>
                  </div>
                : null,
            })}

            <div
              className="flex max-w-sm flex-col items-center justify-center gap-2 p-6 pt-12 text-left only:justify-center only:text-center nnormal:text-left only:nnormal:items-start only:nnormal:text-left"
              //className={`${styles.content} ${IS_NNORMAL ? styles.Nnormal : styles[market]}`}
            >
              <p className="mb-0 text-center text-3xl nnormal:text-left nnormal:font-secondary nnormal:text-base">{t('ficha.producto', 'bundle.title')}</p>
              <div className="nnormal:text-sm" dangerouslySetInnerHTML={{ __html: t('ficha.producto', `bundle.text.${country}`) }} />
            </div>
          </div>
        </div>
      </Dialog>
    </DialogRoot>
  );
}
